<div class="pnl-settings-payment-methods">
  <header>
    <a [routerLink]="['/app/configuracao']" class="back">Configurações</a>
    <h1>Formas de pagamentos</h1>
  </header>

  <form [formGroup]="settingsFrm" (ngSubmit)="onSubmit()" novalidate>
    <section>
      <div>
        <strong>Locais de pagamentos</strong>

        <div class="form-col">
          <mat-checkbox
            id="pagamento_local"
            formControlName="pagamento_local"
            (change)="onChangeDetail()"
            >Pagamento no estabelecimento (drive-thru)</mat-checkbox
          >
        </div>

        <div class="form-col">
          <mat-checkbox
            id="pagamento_entrega"
            formControlName="pagamento_entrega"
            (change)="onChangeDetail()"
            >Pagamento na entrega (delivery)</mat-checkbox
          >
        </div>

        <div class="form-col">
          <mat-checkbox
            id="pagamento_online"
            formControlName="pagamento_online"
            (change)="onChangeDetail()"
            >Pagamento online (* requer a configuração de uma plataforma de
            pagamento)</mat-checkbox
          >
        </div>
      </div>

      <div *ngIf="config_sys">
        <strong>Configuração da plataforma de pagamentos</strong>

        <div class="row">
          <div class="form-col f1 mr5">
            <label>Operadora</label>
            <div class="row">
              <ng-select
                [items]="operadoras"
                (change)="onChangeDetail()"
                formControlName="tipo"
                (clear)="onChangeDetail()"
                placeholder="Operadoras"
                bindLabel="text"
                bindValue="value"
                class="w100"
              ></ng-select>
            </div>
          </div>

          <div class="form-col f2 mr5 ml5">
            <label>Código de identificação</label>
            <div class="row">
              <input
                name="code"
                formControlName="code"
                class="form-control"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>

          <div class="form-col f2 ml5">
            <label>Token (chave de acesso)</label>
            <div class="row">
              <input
                name="token"
                formControlName="token"
                class="form-control"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-col f1 mr5">
            <label>Limite de parcelamento da loja</label>
            <div class="row">
              <input
                name="limite_parcelamento_loja"
                formControlName="limite_parcelamento_loja"
                class="form-control"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
                maxlength="2"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>

          <div class="form-col f1 ml5">
            <label>Juros do parcelamento da loja</label>
            <div class="row">
              <input
                name="juro_parcelamento_loja"
                formControlName="juro_parcelamento_loja"
                class="form-control"
                currencyMask
                [options]="{ precision: 2, allowNegative: false }"
                maxlength="5"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-col f1 mr5">
            <label>Limite de parcelamento da operadora</label>
            <div class="row">
              <input
                name="limite_parcelamento_operadora"
                formControlName="limite_parcelamento_operadora"
                class="form-control"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
                maxlength="2"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>

          <div class="form-col f1 ml5">
            <label>Juros do parcelamento da operadora</label>
            <div class="row">
              <input
                name="juro_parcelamento_operadora"
                formControlName="juro_parcelamento_operadora"
                class="form-control"
                currencyMask
                [options]="{ precision: 2, allowNegative: false }"
                maxlength="5"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-col f1 mr5">
            <label>Parcela mínima</label>
            <div class="row">
              <input
                name="parecela_minima"
                formControlName="parecela_minima"
                class="form-control"
                currencyMask
                [options]="{ precision: 2, allowNegative: false }"
                maxlength="5"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>

          <div class="form-col f1 ml5"></div>
        </div>
      </div>

      <div>
        <strong>Métodos de pagamentos</strong>

        <div class="grid" formArrayName="payment_methods">
          <div class="row header mt10">
            <div class="col">
              <label>Forma</label>
            </div>
            <div class="col">
              <label>Aceita</label>
            </div>
            <div class="col actions"></div>
          </div>
          <div
            class="row"
            *ngFor="
              let grp_payment_methods of payment_methods.controls;
              let i = index
            "
            [formGroupName]="i"
            [class.dnone]="grp_payment_methods.controls.card_id.value == -1"
          >
            <div class="col">
              <ng-select
                [items]="tipos_meio_pagamento"
                (change)="onChangeDetail()"
                formControlName="card_id"
                (clear)="onChangeDetail()"
                placeholder="Selecione"
                bindLabel="ds"
                bindValue="id"
              >
                <ng-template ng-label-tmp ng-option-tmp let-item="item">
                  <div class="ng-select-payment">
                    <img width="30" [src]="item.image" />
                    {{ item.ds }}
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col">
              <ng-select
                [items]="onde_aceita"
                (change)="onChangeDetail()"
                formControlName="accepted"
                (clear)="onChangeDetail()"
                placeholder="Selecione onde aceita"
                bindLabel="text"
                bindValue="value"
              ></ng-select>
            </div>
            <div class="col actions">
              <a
                (click)="onRemovePaymentMethods(i)"
                class="btn-close-round"
              ></a>
            </div>
          </div>
          <div class="row">
            <button
              (click)="onAddNewPaymentMethods(undefined)"
              type="button"
              class="btn btn-green-outline"
            >
              <span>
                <i class="btn-add-round"></i> <span>Adicionar nova forma</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  </form>

  <div class="actions" [class.dflex]="changed">
    <span>Salvar as alterações</span>
    <div>
      <button
        type="button"
        (click)="onCancel()"
        class="btn btn-primary-outline"
      >
        Cancelar
      </button>
      <button type="button" (click)="onSubmit()" class="btn btn-primary">
        Salvar
      </button>
    </div>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
      <div class="ldio-ns36390yc">
        <div></div>
      </div>
    </div>
  </div>
</div>
